module.exports = __webpack_public_path__ + "static/testitwo-b05db673c9add47aa83865ba122adfa2.png";